import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IHttpStrategy } from '@nimbus-library/features/shared/services/base-http/i-http.strategy';

@Injectable({ providedIn: 'root' })
export class HttpStrategyResolver {
  private readonly default: IHttpStrategy;

  private currentStrategy: IHttpStrategy;

  public constructor(http: HttpClient) {
    this.default = http as IHttpStrategy;
  }

  public setStrategy(strategy: IHttpStrategy) {
    this.currentStrategy = strategy;
  }

  public setDefaultStrategy() {
    this.currentStrategy = this.default;
  }

  public getDefaultStrategy(): IHttpStrategy {
    return this.default;
  }

  public getStrategy(): IHttpStrategy {
    return this.currentStrategy || this.default;
  }
}
